import { stringify } from 'querystring';
import { makeEntityScaffold } from '@classpass/saga-tools';
import fetch from '../../../universal-fetch';

export const locationsByMsa = makeEntityScaffold('SAGA.API.LOCATIONS_BY_MSA', (client, msaId) =>
  client.locations.getListV2(msaId).then(data => data.locations)
);

export const locationSearch = makeEntityScaffold('SAGA.GAPI.PLACES_AUTOCOMPLETE', (query, options) =>
  fetch(
    `/_location/search?${stringify({
      input: query,
      ...options,
    })}`,
    { credentials: 'same-origin' }
  )
    .then(response => response.json())
    .then(data => data.predictions)
);

export const geocode = makeEntityScaffold('SAGA.GAPI.GEOCODE', params =>
  fetch(`/_location/geocode?${stringify(params)}`, { credentials: 'same-origin' })
    .then(response => response.json())
    .then(data => data.results && data.results[0])
);
